import { useState } from 'react';
import { Outlet, useNavigate } from 'react-router';
import { AppShell, Title, Text, Button, Flex } from '@mantine/core';
import { useAuth } from '../lib/auth';
import { trpc } from '../lib/trpc';
import Sidebar from './Sidebar';
import PasswordChangeModal from './PasswordChangeModal';

export default function Layout() {
  const { admin, refetch } = useAuth();
  const navigate = useNavigate();
  const [passwordModalOpen, setPasswordModalOpen] = useState(false);

  const signOut = trpc.admin.auth.signOut.useMutation({
    onSuccess: async () => {
      await refetch();
      navigate('/sign-in');
    },
  });

  return (
    <AppShell header={{ height: 56 }} navbar={{ width: 220, breakpoint: 'sm', collapsed: { mobile: false } }} padding="md">
      <AppShell.Header>
        <Flex h="100%" px="md" align="center" justify="space-between">
          <Title order={4}>4each Admin</Title>
          <Flex align="center" gap="md">
            <Text>{admin?.name ?? admin?.username}</Text>
            <Button variant="subtle" onClick={() => setPasswordModalOpen(true)}>
              Change Password
            </Button>
            <Button variant="light" onClick={() => signOut.mutate()} loading={signOut.isPending}>
              Sign Out
            </Button>
          </Flex>
        </Flex>
      </AppShell.Header>

      <AppShell.Navbar p="md">
        <Sidebar />
      </AppShell.Navbar>

      <AppShell.Main>
        <Outlet />
      </AppShell.Main>

      <PasswordChangeModal
        open={passwordModalOpen}
        onClose={() => setPasswordModalOpen(false)}
      />
    </AppShell>
  );
}
